import { set } from 'date-fns'
import { X } from 'lucide-react'
import { useState } from 'react'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { TimePicker as TimePickerComponent } from '@/components/ui/time-picker'
import { cn } from '@/lib/utils'

interface Props {
  values: string[]
  defaultValue?: string
  onChange: (date: Date) => void
  onRemove: (time: string) => void
  setDefaultValue?: (value: string) => void
}

const TimePicker = ({ values, defaultValue, onChange, onRemove, setDefaultValue }: Props) => {
  const [time, setTime] = useState(
    set(new Date(), { hours: 1, minutes: 0, seconds: 0, milliseconds: 0 })
  )

  return (
    <>
      <div className="flex">
        <div className="mb-2 inline-flex">
          <TimePickerComponent
            value={time}
            stepHour={1}
            stepMinute={15}
            onSelect={(e) => e.value && setTime(e.value)}
            className="rounded-r-none"
          />
          <Button className="rounded-l-none" onClick={() => onChange(time)}>
            Hinzufügen
          </Button>
        </div>
      </div>
      <div className="mb-4 flex flex-wrap gap-1 sm:justify-center md:justify-start">
        {values.map((value) => (
          <Badge
            key={value}
            variant={value === defaultValue ? 'default' : 'secondary'}
            className={cn('cursor-pointer gap-1', {
              'hover:bg-primary py-1 transition duration-200 ease-in-out hover:text-white':
                value !== defaultValue,
            })}
            onClick={() => {
              if (setDefaultValue) setDefaultValue(value)
            }}
          >
            {value}
            <X
              className="h-3 w-3 cursor-pointer hover:text-red-500"
              onClick={(e) => {
                e.stopPropagation()
                onRemove(value)
              }}
            />
          </Badge>
        ))}
      </div>
    </>
  )
}

export default TimePicker
